import { CheckCircleOutlined, HighlightOff } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';

import { Actions, Modal, ModalHeader, SecondaryButton, Section } from 'components/common/Modal';

import useTranslate from 'hooks/useTranslate';

interface ResultsAutcomeModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (value: 'success' | 'fail') => void | Promise<void>;
}

export default function ResultsAutcomeModal({
    open,
    onClose,
    onConfirm,
}: ResultsAutcomeModalProps) {
    const { translate } = useTranslate();

    return (
        <Modal
            open={open}
            onClose={onClose}
            size="sm"
            ariaLabel={translate('tellUsTheOutcomeOfTheVisaApplication')}
        >
            <ModalHeader
                eyebrow={translate('visaResults')}
                title={translate('tellUsTheOutcomeOfTheVisaApplication')}
            />

            <Section>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
                    <Button
                        fullWidth
                        type="button"
                        variant="outlined"
                        color="success"
                        startIcon={<CheckCircleOutlined />}
                        onClick={() => void onConfirm('success')}
                        sx={{
                            borderRadius: '14px',
                            justifyContent: 'flex-start',
                            minHeight: 52,
                            px: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                        }}
                    >
                        {translate('approved')}
                    </Button>
                    <Button
                        fullWidth
                        type="button"
                        variant="outlined"
                        color="error"
                        startIcon={<HighlightOff />}
                        onClick={() => void onConfirm('fail')}
                        sx={{
                            borderRadius: '14px',
                            justifyContent: 'flex-start',
                            minHeight: 52,
                            px: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                        }}
                    >
                        {translate('rejected')}
                    </Button>
                </Stack>
            </Section>

            <Actions>
                <SecondaryButton type="button" onClick={onClose}>
                    {translate('cancel')}
                </SecondaryButton>
            </Actions>
        </Modal>
    );
}
